/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Legal_Entity_RequiredInputs */

const cs_settings_office_legal_entity_required = /** @type {(inputs: Settings_Office_Legal_Entity_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro vytvoření právnické osoby je potřeba název firmy.`)
};

const en_settings_office_legal_entity_required = /** @type {(inputs: Settings_Office_Legal_Entity_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company name is required to create a legal entity.`)
};

/**
* | output |
* | --- |
* | "Company name is required to create a legal entity." |
*
* @param {Settings_Office_Legal_Entity_RequiredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_legal_entity_required = /** @type {((inputs?: Settings_Office_Legal_Entity_RequiredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Legal_Entity_RequiredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_legal_entity_required(inputs)
	return cs_settings_office_legal_entity_required(inputs)
});